<template>
	<div class="chain_RelatedReport">
		<h2 class="chain_title1">{{ title }}生命周期图</h2>
		<div id="life-curve" class="flexcss" style="justify-content: start;" data="1">
			<div class="life-box life-box2">
				<div class="circle-infor life-zero" :class="item.css" v-for="item in lifeCircleNodeList" :key="item.id">
					<span class="circle-word">{{ item.name }}</span>
					<span class="mgline"></span>
					<span class="life-circle "></span>
				</div>
				<div class="life-path" style="width: 650px;"></div>
				<ul class="area-line-box" style="top: 26px;">
					<li class="area-line1">导入期</li>
					<li class="area-line2">成长期</li>
					<li class="area-line3">成熟期</li>
					<li class="area-line4">衰退期</li>
				</ul>
			</div>
			<div class="fr life-table-box">
				<table class="w95mg life-table fl" border="0" cellspacing="0" cellpadding="0">
					<tr>
						<th colspan="2" class="font-18">产业生命周期图划分说明</th>
					</tr>
					<tr>
						<th>产业阶段</th>
						<th>说明</th>
					</tr>
					<tr v-for="(list,index) in lifeCircleExplain" :key="index">
						<td :class="index%2==0?'text-center':'text-right text-bold'">{{list.stage}}</td>
						<td>{{list.exp}}</td>
					</tr>
				</table>
			</div>
		</div>

	</div>
</template> 
<script>
export default {
	name: 'chainLifeCycle',
	data() {
		return {
			userdata: {},
			title:'',
			lifeCircleExplain:[
				{stage:'1.导入期',exp:'成长拐点之前的阶段。'},
				{stage:'成长拐点',exp:'第一个被市场接受的规模化产品出现（开始产品商业化）。'},
				{stage:'2.成长期',exp:'成长拐点之后，成熟拐点之前的阶段。'},
				{stage:'成熟拐点',exp:'市场规模增长率，逐步降低到等于或低于本国GDP增长率。'},
				{stage:'3.成熟期',exp:'成熟拐点之后，衰退拐点之前的阶段'},
				{stage:'衰退拐点',exp:'市场规模达到最大峰值，即需求量增速为零或转为负。'},
				{stage:'4.衰退期',exp:'衰退拐点之后的阶段'},
			],
		}
	},
	props: {
		lifeCircleNodeList:{type: Array,default:[],} , 
		chaininformation:{type:Object,default:{}},
	  }, 
	computed: {},

	mounted() {
		window.addEventListener('scroll', this.loadLifeAnmation);
		this.title = this.chaininformation.title.split('链').join('');
	},
	beforeDestroy() {
    	window.removeEventListener('scroll', this.loadLifeAnmation);
  	},
	methods: {
		loadLifeAnmation() {
			let that = this;
				var winTop =  window.scrollY;
				if ($('#life-curve').length > 0) {
					var lifeSvg = $('#life-curve').offset().top;
					var isGet = winTop > (lifeSvg - 657) && winTop < lifeSvg;
					if (isGet && $('#life-curve').attr('data') * 1 == 1) {
						that.cursveAnimate();
					}
				}
		},
		//曲线动画   特定的时间进行动画开始
		cursveAnimate() {
			$('.life-path').animate({ 'width': '650px' },100, function () {
				$('.area-line-box').animate({ 'top': '26px' }, 100, function () {
					//.circle-infor.life-zero
					$('.life-zero').removeClass('life-zero'); console.log('1')
				});
			});
			$('#life-curve').attr('data', 2);
		}

	},

}
</script>

<style scoped>
.chain_RelatedReport{
	min-width: 1430px;
}
</style>
